module.exports = __webpack_public_path__ + "img/wh.94bb4f0e.jpg";